import ProcessAnalysisResultModal from './process-analysis-result-modal.vue'
export default ProcessAnalysisResultModal
